export const MAX_UPLOAD_FILE_SIZE_BYTES = 5 * 1024 * 1024;

export const MAX_UPLOAD_FILE_SIZE_LABEL = "5MB";
